import React, { useEffect, type JSX } from "react";
import DealModalShell from "./DealModalShell";
import type { DealData } from "./dealTypes";

/** The inclusion rationale for a single deal; Escape closes it. */
export default function DealRationaleModal({
  deal,
  onClose,
}: {
  deal: DealData | null;
  onClose: () => void;
}): JSX.Element | null {
  useEffect(() => {
    if (!deal) return;

    const handleKeyDown = (e: KeyboardEvent): void => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [deal, onClose]);

  if (!deal) return null;

  return (
    <DealModalShell title={`Inclusion Rationale: ${deal.dealName || "Deal"}`} onClose={onClose}>
      <div className="p-6 overflow-y-auto">
        <div className="text-base text-gray-700 leading-relaxed">
          {deal.inclusionRationale || "No rationale available for this deal."}
        </div>
      </div>
    </DealModalShell>
  );
}
